export function hasCommonElement(arr1: unknown[], arr2: unknown[]) {
  const set2 = new Set(arr2);
  return arr1.some((el) => set2.has(el));
}
